const CustomResourceApplyXYR = () => import('@/views/main/report/customResourceApply/CustomResourceApplyXYR.vue')
export default {
  path: '/main/report/customResourceApplyXYR',
  name: 'customResourceApplyXYR',
  component: CustomResourceApplyXYR,
  children: []
}
